module.exports = __webpack_public_path__ + "mnet.496682.svg";